/**
 * @file Bullet/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author  []
 */

export const BULLET = " \u00b7 ";
